/**
 * Chailease.SystemManagement.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ToDoListViewModel { 
    companyId?: number;
    companyCode?: string;
    companyShortName?: string;
    companyName?: string;
    systemId?: number;
    systemCode?: string;
    systemName?: string;
    systemFunctionId?: number;
    functionCode?: string;
    functionName?: string;
    processDefKey?: string;
    taskDefKey?: string;
    url?: string;
    processName?: string;
    taskName?: string;
    count?: number;
    multipleRole?: boolean;
}